import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  makeStyles,
  Button,
  Typography,
  Paper,
} from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiGetRequest,
  apiDeleteRequest,
} from "src/utils/api/api";
import News from "./News";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { currentUserIsAuthorized } from "src/utils/utils";
import { userHasAtLeastOnePermission } from "src/utils/userutils";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import KmTabPanel from "src/components/common/KmTabPanel";
import { useParams } from "react-router";
import DraftsView from "./DraftsView";
import { useNavigate } from "react-router-dom";
import PublishedView from "./PublishedView";
import ArchivedView from "./ArchivedView";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { useMountedState } from "react-use";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: theme.spacing(3),
  },
  image: {
    width: 248,
    height: 128,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  title: {
    marginLeft: theme.spacing(3.5),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
  },
  gridzerosp: {
    margin: 0,
    padding: 0,
  },
}));

const NewsListView = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();

  const labelToTabs = {
    wersjerob: 1,
    opublikowane: 2,
    archiwum: 3,
  };

  const { tabId, pageId, rowsCount } = useParams();
  const [value, setValue] = React.useState(
    labelToTabs[tabId] ? labelToTabs[tabId] : 0
  );

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [removingNews, setRemovingNews] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [dialogOpen, setOpen] = useState(false);
  const navigate = useNavigate();

  const [limit, setLimit] = useState(rowsCount ? parseInt(rowsCount) : 5);
  const [page, setPaginatorPage] = useState(pageId ? parseInt(pageId) : 0);
  const [total, setTotal] = useState(null);

  const handleLimitChange = (event) => {
    let newLimit = event.target.value;
    setLimit(newLimit);
    setPaginatorPage(0);
    navigate(`/aktualnosci/strona/0/${newLimit}`);
  };

  const handlePageChange = (event, newPage) => {
    setPaginatorPage(newPage);
    navigate(`/aktualnosci/strona/${newPage}/${limit}`);
  };

  const isMounted = useMountedState();

  useEffect(() => {
    if (isMounted){
      enableGlobalLoader();
      if (isNaN(page) || isNaN(limit)) {
        navigate(`/aktualnosci`);
      } else {
        if (value === 0) {
          sendRequestForNewsPage(pageId ? pageId : 0, limit);
        }
      }
    }
    return () => {};
  }, [reloadCounter, value, page, limit]);

  const sendRequestForNewsPage = (page, newsCount) => {
    apiGetRequest(`${apiEndpoints.getNews.path}/${page}/${newsCount}`, false)
      .then((data) => {
        disableGlobalLoader();
        setRows(data.newsList);
        setTotal(data.totalCount);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
  };

  const handleClickOpen = (news) => {
    setRemovingNews(news);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    if (removingNews) {
      apiDeleteRequest(apiEndpoints.deleteNews.path, [removingNews.id], true)
        .then((data) => {
          disableGlobalLoader();
          setReloadCounter(reloadCounter + 1);
        })
        .catch((error) => {
          disableGlobalLoader();
          setReloadCounter(reloadCounter + 1);
        });
    } else {
      setOpen(false);
    }
  };

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    let tab = Object.keys(labelToTabs).find(
      (key) => labelToTabs[key] === newValue
    );

    setValue(newValue);

    if (tab) {
      navigate(`/aktualnosci/${tab}`);
    } else {
      navigate("/aktualnosci");
    }
  };

  return (
    <Page className={classes.root} title="Aktualności">
      <KmPageTitle>Aktualności</KmPageTitle>

      {currentUserIsAuthorized(globalData) &&
      userHasAtLeastOnePermission(globalData, ["user_admin", "super_admin"]) ? (
        <Container maxWidth={false}>
          <Paper>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                variant="scrollable"
                scrollButtons="on"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="Widok główny" {...a11yProps(0)} />
                <Tab label="Wersje robocze" {...a11yProps(1)} />
                <Tab label="Opublikowane" {...a11yProps(2)} />
                <Tab label="Zarchiwizowane" {...a11yProps(3)} />
              </Tabs>
            </AppBar>
            <KmTabPanel value={value} index={0}>
              <News
                globalData={globalData}
                news={rows}
                handleOpenDocument={handleClickOpen}
                handleLimitChange={handleLimitChange}
                handlePageChange={handlePageChange}
                page={page}
                limit={limit}
                total={total}
              />
            </KmTabPanel>
            <KmTabPanel value={value} index={1}>
              <DraftsView />
            </KmTabPanel>
            <KmTabPanel value={value} index={2}>
              <PublishedView />
            </KmTabPanel>
            <KmTabPanel value={value} index={3}>
              <ArchivedView />
            </KmTabPanel>
          </Paper>
        </Container>
      ) : (
        <Container maxWidth={false}>
          <News
            globalData={globalData}
            news={rows}
            handleOpenDocument={handleClickOpen}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
            page={page}
            limit={limit}
            total={total}
          />
        </Container>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Usuwanie artykułów"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na pewno chcesz usunąć artykuł "
            {removingNews ? removingNews.title : "-"}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Nie
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsListView);
